module.exports = __webpack_public_path__ + "img/9788992036566.34f8e35f.jpg";